// Reducer for Master Time Frame Interval

import {
  GET_MASTER_TIME_FRAME_INTERVAL_LIST,
  GET_MASTER_TIME_FRAME_INTERVAL_LIST_SUCCESS,
  GET_MASTER_TIME_FRAME_INTERVAL_LIST_FAILURE,
} from "./actionType";

const initialState = {
  masterTimeFrameIntervalList: [],
};

const MasterTimeFrameInterval = (state = initialState, action) => {
  switch (action.type) {
    case GET_MASTER_TIME_FRAME_INTERVAL_LIST:
      return { ...state };
    case GET_MASTER_TIME_FRAME_INTERVAL_LIST_SUCCESS:
      return { ...state, masterTimeFrameIntervalList: action.payload };
    case GET_MASTER_TIME_FRAME_INTERVAL_LIST_FAILURE:
      return { ...state };

    default:
      return state;
  }
};

export default MasterTimeFrameInterval;
